export default __webpack_public_path__ + "static/media/google-logo.d478ddc6.svg";